var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dry-power"},[_c('moduleTitle',{attrs:{"title":"服务能力"}}),_c('div',{staticClass:"left"},[_c('Echart',{attrs:{"option":_vm.dbsnOption}})],1),_c('div',{staticClass:"center"},[_c('Echart',{attrs:{"option":_vm.valOption}})],1),_c('div',{staticClass:"right"},[_c('Echart',{attrs:{"option":_vm.dataOption}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }